import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';

export interface ConfirmationDialog {
    title: string;
    message: string;
    warningText?: string;
    confirmText?: string;
    cancelText?: string;
    confirmCallback?: () => void;
    cancelCallback?: () => void;
    type?: 'warning' | 'info';  // Optional: 'warning' = orange header with warning icon, 'info' = blue header with question icon
    confirmButtonType?: 'delete' | 'save' | 'execute';  // Optional: determines confirm button color
}

@Injectable({
    providedIn: 'root'
})
export class ConfirmationService {
    private dialogSubject = new BehaviorSubject<ConfirmationDialog | null>(null);
    public dialog$: Observable<ConfirmationDialog | null> = this.dialogSubject.asObservable();

    constructor() {}

    /**
     * Show a confirmation dialog
     */
    public show(config: ConfirmationDialog): void {
        this.dialogSubject.next(config);
    }

    /**
     * Hide the current confirmation dialog
     */
    public hide(): void {
        this.dialogSubject.next(null);
    }

    /**
     * Get current dialog state
     */
    public getCurrentDialog(): ConfirmationDialog | null {
        return this.dialogSubject.value;
    }
}
